module.exports = __webpack_public_path__ + "static/media/r17.9db3462b.png";